import "./Contact.module.css";
import Header from "@/reusable_sections/Header";
import FindUs from "./sections/FindUs";
import SendAMessage from "./sections/SendAMessage";
import StayUpdated from "./sections/StayUpdated";
import Footer from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <Header />
      <FindUs />
      <SendAMessage />
      <StayUpdated />
      <Footer />
    </div>;
}